import { Box, Button as MuiButton, styled, Box as MuiBox } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";

import { BackArrowIcon, ExportIcon } from "components/Icons";
import { Typography } from "components/Typography";
import { TransactionDetailsTable } from "./components/TransactionDetailsTable";
import { useGetTransactionDetailsQuery } from "api/transactions";
import { formatToNaira } from "utils/formatCurrency";
import { exportCSV } from "utils/exportCsv";
import { STATUS_TYPES } from "pages/Dashboard/components/DashboardChart/components/StatusFilter";

import { Details } from "./components/Details";

const Button = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.sidebar,
  color: "black",
  marginTop: "25px",
  marginBottom: "25px",
  "&:hover": { backgroundColor: "#fafafa" },
}));

const Wrapper = styled(MuiBox)(() => ({
  display: "flex",
  alignItems: "center",
}));

const ExportButton = styled(MuiButton)(() => ({
  borderColor: "#EFF1F4",
  color: "black",
  height: "40px",
  textTransform: "capitalize",
  ".MuiButtonBase-root-MuiButton-root": {
    borderColor: "#EFF1F4 !important",
  },
}));

export const TransactionDetails = () => {
  const params = useParams();
  const transactionId = params.id;

  const { data, isLoading } = useGetTransactionDetailsQuery(transactionId);
  const transactionDetails = data?.transactionDetails || [];

  const navigate = useNavigate();

  const amount =
    transactionDetails?.reduce((acc, item) => acc + item.amount, 0) || 0;
  const totalAmount = formatToNaira(amount);


  const handleExportCsv = () => {
    if (!transactionDetails || !transactionDetails.length) return;

    const exportableRows = transactionDetails.map((row) => ({
      Description: row.description,
      Amount: row.amount,
      Date: row.createdOn
        ? format(new Date(row.createdOn * 1000), "dd/MM/yyyy hh:mm a")
        : "—",
      Status: (() => {
        if (row.status === STATUS_TYPES.FAILED) {
          return "Failed";
        } else if (row.status === STATUS_TYPES.PENDING) {
          return "Pending";
        } else {
          return "Successful";
        }
      })(),
      Reason: row.reason || "",
      "Reference Number": row.transIdRef,
      "Bank Name": row.bankName,
      "Payment Mode": row.paymentMode,
      "Bank Account Number": row.accountNo,
      "Account Name": row.accountName,
      "Debit Bank": row.debitBankName,
      "Debit Account": row.debitAccount,
    }));

    exportCSV(exportableRows, "transaction-details.csv");
  };

  return (
    <Box>

      <Details data={transactionDetails[0]} />
      <Wrapper sx={{ justifyContent: "space-between", margin: "40px 0px" }}>
        <Button
          variant="contained"
          disableRipple
          style={{ margin: 0 }}
          disableElevation
          onClick={() => navigate(-1)}
          disabled={isLoading}
        >
          <BackArrowIcon />
          Back
        </Button>
        <Box sx={{ gap: "10px", display: "flex" }}>
          <ExportButton
            disabled={!transactionDetails?.length}
            variant="outlined"
            onClick={handleExportCsv}
          >
            <Wrapper>
              <ExportIcon />
              <div style={{ marginTop: 5 }}> Export csv</div>
            </Wrapper>
          </ExportButton>
        </Box>
      </Wrapper>
      <Typography variant="dashboardHeading">
        Total Amount: {totalAmount}
      </Typography>
      <TransactionDetailsTable loading={isLoading} data={transactionDetails} />
    </Box>
  );
};
